// extracted by mini-css-extract-plugin
export default {"menuBlock":"PF-z","title":"QF-z","nav":"RF-z","flexCell":"SF-z","facetLink":"TF-z"};